const citiesApi = ({ apiClient }) => ({
    list(params) {
      return apiClient.get('cities', {}, params)
    },
    show(cityId) {
      return apiClient.get(`cities/${cityId}`)
    },
    update(cityId, body) {
      return apiClient.put(`cities/${cityId}`, body)
    },
    store(data) {
      return apiClient.post('cities')
    }
  })

  export default citiesApi
